import api from "../../api";

export const refundOrder = async (original_id: string) => {
  const response = await api.post(`admin/payment/refund/${original_id}`);
  return response.data;
};
